import { Component } from '@angular/core';
import { SpinnerService } from '../../../shared/core.index';
@Component({
    selector: 'app-widget-loader',
    imports: [],
    templateUrl: './widget-loader.component.html',
    styleUrl: './widget-loader.component.scss',
    standalone: true
})
export class WidgetLoaderComponent {
  constructor(private spinner: SpinnerService) {}

  // loading$ = this.spinner.loading$;
}
